/* @flow */
import * as React from 'react';
import Organization from 'entities/Organization';
import Text from 'components/Text.jsx';

class SchoolColleaguesRow extends React.Component<{
  school: Organization,
}> {
  render() {
    const { school } = this.props;
    return (
      <div className="SchoolColleaguesRow">
        <Text truncate>{school.getMemberSampleString()}</Text>
      </div>
    );
  }
}

export default SchoolColleaguesRow;
